ixModuleRouting(
    "impactx.deliverynote",
    {
        "/deliverynotelist": {
            template: "<ixa-delivery-note-list></ixa-delivery-note-list>",
            templateUrl: "modules/deliverynote/templates/deliverynotelist.html",
            process: "DeliveryNote",
            controller: "DeliveryNoteListCtrl",
            controllerAs: "deliveryNoteListCtrl",
            workspace: "shop",
        },
        "/invaliddeliverynotelist": {
            template: "<ixa-invaliddeliverynote-list></ixa-invaliddeliverynote-list>",
            process: "InvalidDeliveryNote",
            workspace: "shop",
        },
        "/deliverynote": {
            template: "<ixa-edit-delivery-note></ixa-edit-delivery-note>",
            templateUrl: "modules/deliverynote/templates/deliverynote.html",
            process: "EditDeliveryNote",
            controller: "DeliveryNoteCtrl",
            controllerAs: "deliveryNoteCtrl",
            workspace: "shop",
        },
        "/deliverynote/:messages/:warnings/:errors": {
            template: "<ixa-edit-delivery-note></ixa-edit-delivery-note>",
            templateUrl: "modules/deliverynote/templates/deliverynote.html",
            process: "EditDeliveryNote",
            controller: "DeliveryNoteCtrl",
            controllerAs: "deliveryNoteCtrl",
            workspace: "shop",
        },
        "/deliverynote/:pohid": {
            template: "<ixa-edit-delivery-note></ixa-edit-delivery-note>",
            templateUrl: "modules/deliverynote/templates/deliverynote.html",
            process: "EditDeliveryNote",
            controller: "DeliveryNoteCtrl",
            controllerAs: "deliveryNoteCtrl",
            workspace: "shop",
        },
        "/deliverynote/:pohid/:messages/:warnings/:errors": {
            template: "<ixa-edit-delivery-note></ixa-edit-delivery-note>",
            templateUrl: "modules/deliverynote/templates/deliverynote.html",
            process: "EditDeliveryNote",
            controller: "DeliveryNoteCtrl",
            controllerAs: "deliveryNoteCtrl",
            workspace: "shop",
        },
        "/deliverynote/edit/:id": {
            template: "<ixa-edit-delivery-note></ixa-edit-delivery-note>",
            templateUrl: "modules/deliverynote/templates/deliverynote.html",
            process: "EditDeliveryNote",
            controller: "DeliveryNoteCtrl",
            controllerAs: "deliveryNoteCtrl",
            workspace: "shop",
        },
        "/deliverynote/edit/:id/:messages/:warnings/:errors": {
            template: "<ixa-edit-delivery-note></ixa-edit-delivery-note>",
            templateUrl: "modules/deliverynote/templates/deliverynote.html",
            process: "EditDeliveryNote",
            controller: "DeliveryNoteCtrl",
            controllerAs: "deliveryNoteCtrl",
            workspace: "shop",
        },
        "/deliverynotedetail/:id": {
            template: "<ixa-delivery-note-detail></ixa-delivery-note-detail>",
            templateUrl:
                "modules/deliverynote/templates/deliverynotedetail.html",
            process: "ViewDeliveryNote",
            controller: "DeliveryNoteDetailCtrl",
            controllerAs: "deliveryNoteDetailCtrl",
            workspace: "shop",
        },
    },
    ["ngRoute", "impactx.list", "impactx.statusicon"]
);
